/* eslint-disable global-require */
import React, { ReactElement } from 'react'
import { Helmet } from 'react-helmet-async'
import smartBannerMetaTag, { enabledPlatform } from './smartBannerMetaTag'

const SmartBanner = (): ReactElement => {
  if (enabledPlatform === 'android') {
    require('../../../../node_modules/smartbanner.js/dist/smartbanner.min')
    require('../../../../node_modules/smartbanner.js/dist/smartbanner.min.css')
  }

  return (
    <Helmet>
      {smartBannerMetaTag.map(metaTag => (
        <meta
          key={metaTag.name}
          name={metaTag.name}
          content={metaTag.content}
        />
      ))}
    </Helmet>
  )
}

export default SmartBanner
